export default __webpack_public_path__ + "static/lauren-tapp-4bd3afedb3117dc8ac1a06be5867a8e5.png";